function initArchiveDropdown() {
    // Previeni esecuzioni multiple
    if (document.querySelector('.gh-month-section')) {
        return;
    }
    
    const posts = document.querySelectorAll('.gh-archive-post');
    const sidebar = document.getElementById('month-sidebar');
    const container = document.getElementById('posts-container');
    
    // Verifica che gli elementi esistano
    if (!posts.length || !sidebar || !container) {
        return;
    }
    
    // Funzione per normalizzare il formato del mese (prima lettera maiuscola)
    function normalizeMonth(monthString) {
        return monthString.charAt(0).toUpperCase() + monthString.slice(1).toLowerCase();
    }
    
    // Ottieni il mese corrente formattato nello stesso modo dei dati
    const now = new Date();
    const currentMonthFormatted = now.toLocaleDateString('it-IT', { 
        month: 'long', 
        year: 'numeric' 
    }).toLowerCase(); // Usiamo lowercase per confronto
    
    // Prima passata: raccogliere tutti i mesi unici
    const monthSet = new Set();
    posts.forEach(post => {
        const month = post.getAttribute('data-month');
        monthSet.add(month.toLowerCase()); // Normalizziamo a lowercase
    });
    
    // Ordina i mesi dal più recente al più vecchio
    const sortedMonths = Array.from(monthSet).sort((a, b) => {
        const dateA = new Date(a);
        const dateB = new Date(b);
        return dateB - dateA;
    });
    
    // Crea la sidebar con mesi capitalizzati per la visualizzazione
    sortedMonths.forEach(month => {
        const monthElement = document.createElement('button');
        monthElement.type = 'button';
        monthElement.className = 'gh-archive-month-link';
        monthElement.dataset.month = month; // Salva in lowercase
        monthElement.textContent = normalizeMonth(month); // Visualizza capitalizzato
        
        if (month === currentMonthFormatted) {
            monthElement.classList.add('active');
        }
        
        sidebar.appendChild(monthElement);
    });
    
    // Crea le sezioni per mese
    const monthSections = new Map();
    
    sortedMonths.forEach(month => {
        // Crea la sezione
        const section = document.createElement('div');
        section.className = 'gh-month-section';
        section.id = 'month-' + month.replace(/\s+/g, '-').toLowerCase();
        section.dataset.month = month; // Salva in lowercase
        
        // Verifica se è il mese corrente
        const isCurrentMonth = month === currentMonthFormatted;

        // Se NON è il mese corrente, aggiungi classe collapsed
        if (!isCurrentMonth) {
            section.classList.add('collapsed');
        }
        
        // Crea l'header con testo capitalizzato
        const header = document.createElement('h2');
        header.className = 'gh-month-header';
        header.dataset.month = month; // Salva in lowercase
        header.innerHTML = normalizeMonth(month) + '<span class="gh-month-toggle">▼</span>';
        
        if (isCurrentMonth) {
            header.classList.add('active');
        }
        
        // Crea il contenitore dei post
        const postsWrapper = document.createElement('div');
        postsWrapper.className = 'gh-month-posts';
        
        // Mostra i post solo per il mese corrente inizialmente
        if (isCurrentMonth) {
            postsWrapper.style.display = 'block';
        } else {
            postsWrapper.style.display = 'none';
        }
        
        section.appendChild(header);
        section.appendChild(postsWrapper);
        
        monthSections.set(month, {
            element: section,
            header: header,
            postsWrapper: postsWrapper,
            posts: [],
            isCurrentMonth: isCurrentMonth
        });
        
        // Aggiungi al container
        container.appendChild(section);
    });
    
    // Assegna i post alle rispettive sezioni
    posts.forEach(post => {
        const month = post.getAttribute('data-month').toLowerCase(); // Normalizza a lowercase
        const sectionData = monthSections.get(month);
        
        if (sectionData) {
            // Tronca l'excerpt se necessario
            const excerptElement = post.querySelector('.gh-archive-post-excerpt');
            if (excerptElement) {
                const text = excerptElement.textContent;
                if (text.length > 150) {
                    excerptElement.textContent = text.substring(0, 150) + '...';
                }
            }
            
            // Segna il post come organizzato
            post.setAttribute('data-organized', 'true');
            post.style.display = 'flex'; // Mostra il post
            
            sectionData.postsWrapper.appendChild(post);
            sectionData.posts.push(post);
        }
    });
    
    // Rimuovi i post originali non organizzati
    const unorganizedPosts = container.querySelectorAll('.gh-archive-post[data-organized="false"]');
    unorganizedPosts.forEach(post => post.remove());
    
    // Funzione per aprire/chiudere una sezione
    function toggleMonthSection(monthToToggle) {
        const sectionData = monthSections.get(monthToToggle);
        if (!sectionData) return;
        
        const isCurrentMonth = sectionData.isCurrentMonth;
        const isCollapsed = sectionData.element.classList.contains('collapsed');
        
        if (isCollapsed) {
            // Apri questa sezione
            sectionData.element.classList.remove('collapsed');
            sectionData.postsWrapper.style.display = 'block';
            sectionData.header.classList.add('active');
            
            // Chiudi tutte le altre sezioni (INCLUSO il mese corrente se è diverso)
            monthSections.forEach((data, month) => {
                if (month !== monthToToggle) {
                    data.element.classList.add('collapsed');
                    data.postsWrapper.style.display = 'none';
                    data.header.classList.remove('active');
                }
            });
        } else {
            // Se è già aperto e non è il mese corrente, chiudilo
            // Se è il mese corrente e si clicca di nuovo, lascialo aperto
            if (!isCurrentMonth) {
                sectionData.element.classList.add('collapsed');
                sectionData.postsWrapper.style.display = 'none';
                sectionData.header.classList.remove('active');
            }
        }
        
        // Aggiorna gli stati attivi nella sidebar
        updateSidebarActiveStates();
        
        // Scroll alla sezione (solo su desktop)
        if (window.innerWidth > 768) {
            sectionData.element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
    
    // Funzione per aggiornare gli stati attivi nella sidebar
    function updateSidebarActiveStates() {
        sidebar.querySelectorAll('.gh-archive-month-link').forEach(link => {
            link.classList.remove('active');
            const linkMonth = link.dataset.month;
            const sectionData = monthSections.get(linkMonth);
            
            if (sectionData && !sectionData.element.classList.contains('collapsed')) {
                link.classList.add('active');
            }
        });
    }
    
    // Aggiorna gli stati iniziali nella sidebar
    updateSidebarActiveStates();
    
    // Gestione dei click nella sidebar
    sidebar.addEventListener('click', function(e) {
        const monthLink = e.target.closest('.gh-archive-month-link');
        if (monthLink) {
            const month = monthLink.dataset.month;
            toggleMonthSection(month);
        }
    });
    
    // Gestione dei click sugli header
    container.addEventListener('click', function(e) {
        const monthHeader = e.target.closest('.gh-month-header');
        if (monthHeader) {
            const month = monthHeader.dataset.month;
            toggleMonthSection(month);
            e.preventDefault();
        }
    });
    
    container.classList.add('loaded');
}

// Esegui solo quando il DOM è pronto
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArchiveDropdown);
} else {
    // DOM già caricato
    initArchiveDropdown();
}